module.exports = __webpack_public_path__ + "img/DaSoIrgendwo.7cb081b2.jpg";